import { Box, CircularProgress } from '@mui/material';
import { FC, useCallback, useEffect, useState } from 'react';
import { usePlayerContext } from './PlayerContext';

type BufferingEvent = Event & {
  buffering: boolean;
};

const boxStyles = { pointerEvents: 'none' };

export const Buffering: FC = () => {
  const { player } = usePlayerContext();
  const [buffering, setIsBuffering] = useState(player?.isBuffering());

  const bufferingHandler = useCallback((event: Event) => setIsBuffering((event as BufferingEvent).buffering), []);

  useEffect(() => {
    player?.addEventListener('buffering', bufferingHandler);
    return () => {
      player?.removeEventListener('buffering', bufferingHandler);
    };
  });
  return (
    <Box
      width="100%"
      height="100%"
      position="absolute"
      display="flex"
      alignItems="center"
      justifyContent="center"
      sx={boxStyles}
    >
      {buffering && <CircularProgress color="secondary" size="100px" />}
    </Box>
  );
};
